import { render, staticRenderFns } from "./chooseimgone.vue?vue&type=template&id=2de475f4&scoped=true"
import script from "./chooseimgone.vue?vue&type=script&lang=js"
export * from "./chooseimgone.vue?vue&type=script&lang=js"
import style0 from "./chooseimgone.vue?vue&type=style&index=0&id=2de475f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de475f4",
  null
  
)

export default component.exports